// extracted by mini-css-extract-plugin
module.exports = {"toggleBgTransition":"background-color 300ms ease-in"};